import { render, staticRenderFns } from "./PostSelect.vue?vue&type=template&id=1f6da9c9&scoped=true"
import script from "./PostSelect.vue?vue&type=script&lang=js"
export * from "./PostSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6da9c9",
  null
  
)

export default component.exports